export const transportationQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "A train is approaching the platform.",
      B: "A clock is mounted on the ceiling.",
      C: "Passengers are waiting in line.",
      D: "A ticket vending machine is being used.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 천장에 시계가 설치되어 있음\n" +
      "오답 설명: (A) 기차가 다가오는 모습은 보이지 않음, (C) 플랫폼에 사람들이 보이지 않음, (D) 자동발권기 사용 중인 장면은 보이지 않음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "A train door is being closed.",
      B: "A passenger is stepping onto the train.",
      C: "The train is moving away from the platform.",
      D: "One of the train doors has been left open at the platform.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 기차의 문 하나가 열려있는 상태임\n" +
      "오답 설명: (A) 기차 문이 닫히는 장면은 보이지 않음, (B) 승객이 탑승하는 모습은 보이지 않음, (C) 기차가 출발하는 모습은 보이지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "A passenger is holding onto a handrail.",
      B: "The train doors are being closed.",
      C: "The seats are unoccupied.",
      D: "Passengers are boarding the train.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 좌석이 비어있는 상태임\n" +
      "오답 설명: (A) 손잡이가 있지만, 승객이 잡고 있는 모습은 보이지 않음, (B) 열차 문이 열려 있지만, 닫히는 장면은 보이지 않음, (D) 승객들이 보이지 않음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "A train is departing from the platform.",
      B: "A train is approaching the platform.",
      C: "The benches at the platform are unoccupied.",
      D: "A clock is being installed on the wall.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 플랫폼의 벤치가 비어있는 상태임\n" +
      "오답 설명: (A) 기차가 출발하는 모습은 보이지 않음, (B) 기차는 이미 도착한 상태임, (D) 시계는 이미 설치되어 있는 상태임",
  },
  {
    questionNumber: 5,
    choices: {
      A: "A train is approaching the platform.",
      B: "Some passengers are boarding the train.",
      C: "The benches at the platform are occupied.",
      D: "The train is departing from the platform.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 기차가 플랫폼으로 접근하고 있음\n" +
      "오답 설명: (B) 승객이 탑승하는 모습은 보이지 않음, (C) 벤치에 사람이 앉아 있는 모습은 보이지 않음, (D) 기차가 도착하고 있는 중임",
  },
  {
    questionNumber: 6,
    choices: {
      A: "A passenger is placing luggage on the scale.",
      B: "The check-in counters are unoccupied.",
      C: "An airline employee is assisting a traveler.",
      D: "A digital display is showing flight departure times.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 체크인 카운터가 비어있는 상태임\n" +
      "오답 설명: (A) 승객이 짐을 올리는 모습은 보이지 않음, (C) 직원이 승객을 돕는 장면은 보이지 않음, (D) 전광판이 있지만, 항공편 출발 시간이 표시된 것은 보이지 않음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "A passenger is retrieving luggage from the conveyor belt.",
      B: "A suitcase is being placed onto the belt.",
      C: "A baggage claim area is crowded with travelers.",
      D: "Several suitcases are on a conveyor belt.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 컨베이어 벨트 위에 여러 개의 수하물이 있음\n" +
      "오답 설명: (A) 승객이 짐을 가져가는 모습은 보이지 않음, (B) 누군가가 짐을 올리는 장면은 보이지 않음, (C) 사람들이 붐비는 모습은 보이지 않음",
  },

  {
    questionNumber: 8,
    choices: {
      A: "Signs are being installed in the airport.",
      B: "A security officer is checking a traveler's passport.",
      C: "Directional signs for airport gates are displayed.",
      D: "A flight schedule is being updated on the screen.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 공항 게이트 방향을 안내하는 표지판이 설치되어 있음\n" +
      "오답 설명: (A) 표지판은 이미 설치되어 있는 상태임, (B) 보안 검색대나 여권 심사 장면은 보이지 않음, (D) 전광판이 있지만, 항공편 일정이 업데이트되는 것은 보이지 않음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "A passenger is picking up a suitcase from the conveyor belt.",
      B: "The baggage claim area is empty.",
      C: "Some luggage is being loaded onto the belt.",
      D: "A flight schedule is displayed on the monitor.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 수하물 찾는 곳이 비어있는 상태임\n" +
      "오답 설명: (A) 승객이 짐을 가져가는 모습은 보이지 않음, (C) 직원이 수하물을 올리는 장면은 보이지 않음, (D) 모니터가 있지만, 항공편 일정이 표시된 것은 보이지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "A pedestrian is crossing the highway.",
      B: "A traffic light is being installed at an intersection.",
      C: "Vehicles are traveling in the same direction.",
      D: "A barrier divides the lanes on the highway.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 도로의 차선을 구분하는 중앙분리대가 설치되어 있음\n" +
      "오답 설명: (A) 보행자가 건너는 모습은 보이지 않음, (B) 신호등이 설치되는 장면은 보이지 않음, (C) 차량들이 서로 다른 방향으로 주행 중임",
  },
  {
    questionNumber: 11,
    choices: {
      A: "A row of streetlights lines the highway.",
      B: "A pedestrian is walking along the median strip.",
      C: "Several vehicles are stopped at a traffic signal.",
      D: "A bridge is being constructed over the road.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 도로를 따라 가로등이 설치되어 있음\n" +
      "오답 설명: (B) 보행자가 걷는 모습은 보이지 않음, (C) 차량들이 신호에 멈춰있는 모습은 보이지 않음, (D) 다리가 공사 중인 모습은 보이지 않음",
  },

  {
    questionNumber: 12,
    choices: {
      A: "A bus is approaching the stop.",
      B: "A group of people is waiting for transportation.",
      C: "The bench at the bus stop is unoccupied.",
      D: "A bus stop sign is being mounted.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 버스 정류장의 벤치가 비어있는 상태임\n" +
      "오답 설명: (A) 버스가 도착하는 모습은 보이지 않음, (B) 사람들이 기다리는 모습은 보이지 않음, (D) 버스 정류장 표지판은 이미 설치되어 있음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "A bus is stopped at a station.",
      B: "A passenger is stepping onto the bus.",
      C: "The advertisement board is being replaced.",
      D: "The bus is departing from the station.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 버스가 정류장에 정차해 있는 상태임\n" +
      "오답 설명: (B) 승객이 탑승하는 장면은 보이지 않음, (C) 광고판이 교체되는 장면은 보이지 않음, (D) 버스는 정류장에 멈춰있는 상태이며 출발하는 중이 아님",
  },
  {
    questionNumber: 14,
    choices: {
      A: "A road sign is posted along the roadside.",
      B: "A traffic light is being installed at an intersection.",
      C: "Pedestrians are crossing the street.",
      D: "Vehicles are waiting at a red light.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 도로변에 도로 표지판이 설치되어 있음\n" +
      "오답 설명: (B) 신호등이 설치되는 장면은 보이지 않음, (C) 보행자가 길을 건너는 모습은 보이지 않음, (D) 차량이 신호등 앞에 멈춰있는 모습은 보이지 않음",
  },
  {
    questionNumber: 15,
    choices: {
      A: "A plane is moving along the runway.",
      B: "An aircraft is landing on the runway.",
      C: "An aircraft is taking off from the runway.",
      D: "Passengers are boarding the aircraft.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 비행기가 활주로에서 이륙하는 중임\n" +
      "오답 설명: (A) 비행기가 활주로를 따라 이동하는 것이 아니라 이륙하는 중임, (B) 비행기가 착륙하는 것이 아니라 이륙하는 중임, (D) 승객이 탑승하는 장면은 보이지 않음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "Pedestrians are crossing the street.",
      B: "A cyclist is waiting at the traffic light.",
      C: "A bicycle lane is marked on the road.",
      D: "Vehicles are moving through the intersection.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 도로에 자전거 전용 차선이 표시되어 있음\n" +
      "오답 설명: (A) 횡단보도는 있으나 길을 건너는 사람은 보이지 않음, (B) 자전거 도로와 신호등은 있으나 자전거를 탄 사람은 없음, (D) 차량들이 있으나 빨간 신호로 인해 교차로를 통과하지 않음",
  },
  {
    questionNumber: 17,
    choices: {
      A: "A pedestrian is crossing the street at the intersection.",
      B: "A cyclist is waiting at the red light.",
      C: "Vehicles are moving through a busy intersection.",
      D: "Traffic lights are hanging above the road.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 차량들이 붐비는 교차로를 지나고 있음\n" +
      "오답 설명: (A) 횡단보도는 있으나 길을 건너는 보행자는 보이지 않음, (B) 자전거 전용 차선은 있으나 신호를 기다리는 자전거 이용자는 없음, (D) 신호등이 도로 위에 매달려 있지 않고 기둥에 설치되어 있음",
  },
  {
    questionNumber: 18,
    choices: {
      A: "A pedestrian crossing sign is mounted on a pole.",
      B: "A traffic light is hanging from a pole.",
      C: "A pedestrian is crossing the street.",
      D: "A car is stopped at the intersection.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) 횡단보도 표시가 기둥에 부착되어 있음\n" +
      "오답 설명: (B) 신호등이 있지만 기둥에 설치되어 있으며 'hanging'이라는 표현은 적절하지 않음, (C) 횡단보도가 있지만 보행자가 도로를 건너는 모습은 보이지 않음, (D) 도로에 차들이 있지만 교차로에서 멈춰 있는 차량은 보이지 않음",
  },
  {
    questionNumber: 19,
    choices: {
      A: "A worker is directing traffic at the construction site.",
      B: "A car is driving through the construction zone.",
      C: "Traffic is being diverted due to roadwork.",
      D: "A pedestrian is crossing the street.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '도로 공사로 인해 교통이 우회되고 있다' → 사진 속 도로 공사로 인해 차량이 우회해야 하므로 유일한 정답\n\n오답 설명:\n\n(A) '작업자가 공사 현장에서 교통을 정리하고 있다' → 공사 구역이지만 교통을 정리하는 작업자가 보이지 않음,\n\n(B) '자동차가 공사 구역을 통과하고 있다' → 공사 구역이 보이지만 도로가 차단되어 있어 차량이 통과할 수 없음,\n\n(D) '보행자가 도로를 건너고 있다' → 횡단보도가 없고 보행자도 보이지 않음",
  },
  {
    questionNumber: 20,
    choices: {
      A: "A traffic officer is directing vehicles.",
      B: "A pedestrian is crossing the road between cars.",
      C: "Several buses are parked along the street.",
      D: "The highway is congested with heavy traffic.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '고속도로가 심한 교통체증으로 혼잡하다' → 사진 속 고속도로에 많은 차량이 정체되어 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '교통 경찰관이 차량들을 통제하고 있다' → 도로에 차량이 많지만 교통을 정리하는 경찰관은 보이지 않음,\n\n(B) '보행자가 차들 사이로 도로를 건너고 있다' → 차량이 많지만 길을 건너는 보행자는 보이지 않음,\n\n(C) '여러 대의 버스가 도로를 따라 주차되어 있다' → 사진 속 도로에 차량이 많지만 버스가 줄지어 주차되어 있지는 않음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "A pedestrian is walking on the sidewalk.",
      B: "A traffic signal is hanging above the intersection.",
      C: "Traffic cones are placed along the roadside.",
      D: "A worker is removing the construction barriers.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) 도로변에 교통 콘이 놓여 있음\n\n오답 설명:\n\n(A) 'SIDEWALK CLOSED'(인도 폐쇄) 표지판이 있으며, 보행자가 없음,\n\n(B) 도로와 공사 구역이 있지만, 신호등(traffic signal)이 보이지 않음,\n\n(D) 작업자들이 있지만, 공사용 방어벽(barriers)을 제거하는 장면은 보이지 않음",
  },
  {
    questionNumber: 22,
    choices: {
      A: "A train is approaching from a distance.",
      B: "A railway worker is inspecting the tracks.",
      C: "Multiple railway tracks stretch into the distance.",
      D: "A pedestrian is walking along the tracks.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) 여러 개의 철도 선로가 멀리까지 뻗어 있음\n\n오답 설명:\n\n(A) '기차가 멀리서 다가오고 있다' → 철도 선로가 있지만 기차는 보이지 않음,\n\n(B) '철도 작업자가 선로를 점검하고 있다' → 철도와 주변 설비는 있지만 작업자는 보이지 않음,\n\n(D) '보행자가 선로를 따라 걷고 있다' → 철도 주변에 사람이 없음",
  },
  {
    questionNumber: 23,
    choices: {
      A: "A pedestrian is walking along the railway tracks.",
      B: "A train is traveling along the tracks.",
      C: "The train station is crowded with passengers.",
      D: "Workers are repairing the railway.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '기차가 철도 선로를 따라 이동하고 있다' → 사진 속 기차가 철도 선로를 따라 이동하고 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '보행자가 철도 선로를 따라 걷고 있다' → 철도 주변이지만 보행자가 없으므로 오답,\n\n(C) '기차역이 승객들로 붐비고 있다' → 철도와 기차는 있지만 승강장이나 승객이 보이지 않으므로 오답,\n\n(D) '작업자들이 철도를 수리하고 있다' → 철로 주변이지만 철도를 수리하는 작업자는 보이지 않으므로 오답",
  },
  {
    questionNumber: 24,
    choices: {
      A: "Several cars are parked in the lot.",
      B: "A security guard is patrolling the parking area.",
      C: "The parking lot is unoccupied.",
      D: "People are walking between the parked cars.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '주차장이 비어있다' → 사진 속 주차장에 차가 한 대도 없으며, 공간이 비어 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '여러 대의 차가 주차장에 주차되어 있다' → 주차장이 보이지만 차량이 없으므로 오답,\n\n(B) '경비원이 주차 구역을 순찰하고 있다' → 주차장이 넓게 보이지만 경비원이 없으므로 오답,\n\n(D) '사람들이 주차된 차들 사이로 걷고 있다' → 주차된 차량이 없으며 보행자도 보이지 않으므로 오답",
  },
  {
    questionNumber: 25,
    choices: {
      A: "A group of people is boarding the cruise ship.",
      B: "Fishing boats are floating near the shore.",
      C: "A cruise ship is sailing near the harbor.",
      D: "The cruise ship is docked at the port.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '크루즈선이 항구 근처에서 항해하고 있다' → 사진 속 크루즈선이 항구(harbor) 근처에서 항해(sailing)하고 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '승객들이 크루즈선에 승선하고 있다' → 사진 속 크루즈선(cruise ship)이 있지만, 승객들이 승선하는 장면은 보이지 않으므로 오답,\n\n(B) '어선들이 해안가 근처에 떠 있다' → 사진 속 항구(marina)에 여러 배가 있지만, 작은 어선(fishing boats)이 보이지 않으므로 오답,\n\n(D) '크루즈선이 항구에 정박해 있다' → 배가 정박(docked)한 것이 아니라, 이동 중이므로 오답",
  },
  {
    questionNumber: 26,
    choices: {
      A: "A boat is tied to the dock.",
      B: "A boat is floating in the middle of the lake.",
      C: "The dock is completely empty.",
      D: "People are boarding the boat.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '보트가 부두에 묶여있다' → 사진 속 보트가 부두에 계류되어 있으므로 유일한 정답\n\n오답 설명:\n\n(B) '보트가 호수 한가운데 떠 있다' → 보트가 부두에 묶여 있으므로 오답,\n\n(C) '부두가 완전히 비어있다' → 부두에 보트가 있으므로 오답,\n\n(D) '사람들이 보트에 승선하고 있다' → 보트는 있지만 승선하는 사람들이 보이지 않으므로 오답",
  },
  {
    questionNumber: 27,
    choices: {
      A: "The cruise ship is docked at the port.",
      B: "The ship is being loaded with cargo.",
      C: "A large cruise ship is sailing on the ocean.",
      D: "The passengers are getting off the ship.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '대형 크루즈선이 바다 위를 항해하고 있다' → 사진 속 크루즈선이 바다를 항해하고 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '크루즈선이 항구에 정박해 있다' → 크루즈선이 정박해 있지 않고 항해 중이므로 오답,\n\n(B) '배에 화물을 싣고 있다' → 크루즈선은 보이지만 화물 적재 작업이 보이지 않으므로 오답,\n\n(D) '승객들이 배에서 내리고 있다' → 크루즈선은 항해 중이며 승객들이 하선하는 모습이 보이지 않으므로 오답",
  },
  {
    questionNumber: 28,
    choices: {
      A: "The ship's deck is empty.",
      B: "A group of people is walking along the deck.",
      C: "A lifeboat is floating in the water.",
      D: "A rescue team is assisting passengers.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '배의 갑판이 비어있다' → 사진 속 배의 갑판에 아무도 없고 비어있으므로 유일한 정답\n\n오답 설명:\n\n(B) '사람들이 갑판을 따라 걷고 있다' → 갑판은 보이지만 걷고 있는 사람들이 없으므로 오답,\n\n(C) '구명보트가 물 위에 떠 있다' → 구명보트가 보이지 않으므로 오답,\n\n(D) '구조팀이 승객들을 돕고 있다' → 구조팀이나 승객이 보이지 않으므로 오답",
  },
  {
    questionNumber: 29,
    choices: {
      A: "The pier is crowded with people.",
      B: "A fishing boat is docked at the pier.",
      C: "A large boat is floating near the pier.",
      D: "The pier is covered with metal railings.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '큰 배가 부두 근처에 떠 있다' → 사진 속 큰 배가 부두 근처에서 떠 있는 것이 보이므로 유일한 정답\n\n오답 설명:\n\n(A) '부두에 사람들이 붐비고 있다' → 부두는 보이지만 사람들이 붐비는 모습은 보이지 않으므로 오답,\n\n(B) '어선이 부두에 정박해 있다' → 큰 배는 보이지만 부두에 정박한 어선은 보이지 않으므로 오답,\n\n(D) '부두가 금속 난간으로 덮여 있다' → 부두는 보이지만 금속 난간이 덮여있는 모습은 보이지 않으므로 오답",
  },
  {
    questionNumber: 30,
    choices: {
      A: "Several boats are docked at the marina.",
      B: "A large cruise ship is departing from the harbor.",
      C: "The boats are floating in the middle of the ocean.",
      D: "People are boarding the boats.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '여러 척의 보트가 마리나에 정박해 있다' → 사진 속 여러 척의 보트가 마리나에 정박해 있으므로 유일한 정답\n\n오답 설명:\n\n(B) '대형 크루즈선이 항구에서 출발하고 있다' → 크루즈선이 보이지 않으므로 오답,\n\n(C) '보트들이 대양 한가운데 떠 있다' → 보트들이 마리나에 정박해 있지 대양에 떠 있지 않으므로 오답,\n\n(D) '사람들이 보트에 승선하고 있다' → 보트는 보이지만 승선하는 사람들이 보이지 않으므로 오답",
  },
];
